import { Accordion, Col, Container, Row } from "react-bootstrap";
import DetailItem from "./DataItem";
import department from "../../../Assets/images/profile-managment/department.svg"
import userid from "../../../Assets/images/profile-managment/userid.svg"
import email from "../../../Assets/images/profile-managment/email.png"
import call from "../../../Assets/images/profile-managment/call.svg" 
import telephone from "../../../Assets/images/profile-managment/telephone.svg" 

import role from "../../../Assets/images/profile-managment/role.svg"
const GeneralRequirementAccordion= ({sampleRequestDetails})=>{
return(
    // <Accordion className="accordion-item" defaultActiveKey="1" flush>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header><b>General Requirements</b></Accordion.Header>
                                            <Accordion.Body>
                                                {/* Container -> div */}
                                                <div className="el-property-details-card-content">
                                                    <Row>
                                                        <Col md={12} className="mx-fit-content">
                                                            <div className="flex-sec">
                                                                <DetailItem
                                                                    iconSrc={userid}
                                                                    title="Smokers Allowed?"
                                                                    detail={sampleRequestDetails?.request?.smoker_allowed == 'yes' ? 'Yes' : 'No' || '-'}
                                                                />
                                                                <DetailItem
                                                                    iconSrc={email}
                                                                    title="Vitamins & Herbal Supplements allowed"
                                                                    detail={sampleRequestDetails?.request?.herbal_vitamins == 'yes' ? 'Yes' : 'No' || '-'}
                                                                />


                                                                <DetailItem
                                                                    iconSrc={telephone}
                                                                    title="All Medications Allowed?"
                                                                    detail={sampleRequestDetails?.request?.medication_allowed == 'yes' ? 'Yes' : 'No' || '-'}
                                                                />

                                                                {sampleRequestDetails?.request?.medication_allowed == 'no' && (<DetailItem
                                                                    iconSrc={call}
                                                                    title="Excluded Medications"
                                                                    detail={sampleRequestDetails?.request?.medication_reason || '-'}
                                                                />)}
                                                                {sampleRequestDetails?.request?.herbal_vitamins == 'no' && (
                                                                    <DetailItem
                                                                        iconSrc={department}
                                                                        // title="Waiting Period"
                                                                        title="Minimum time since last dose of vitamins/supplements or medications"
                                                                        // Minimum time since last dose of vitamins/supplements or medications:
                                                                        detail={sampleRequestDetails?.request?.herbal_vitamin_note || '-'}
                                                                    />)}

                                                                {/* <DetailItem
                                                                    iconSrc={role}
                                                                    title="Donor Restrictions"
                                                                    detail={sampleRequestDetails?.request?.donor_restriction_note || '-'}
                                                                /> */}
                                                                <DetailItem
                                                                    iconSrc={role}
                                                                    title="Donor Inclusions"
                                                                    detail={sampleRequestDetails?.request?.donor_inclusion || '-'}
                                                                />

                                                                <DetailItem
                                                                    iconSrc={role}
                                                                    title="Donor Exclusions"
                                                                    detail={sampleRequestDetails?.request?.donor_exclusion || '-'}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    // </Accordion>
);

}

export default GeneralRequirementAccordion